import React from 'react'
import styled from 'styled-components'
import NojaThankYou from './NojaThankYou'
import NojaSendForm from './NojaSendForm'
import { useLocalStorage } from '@root/hooks'
import { useBusinessContext } from '@root/context'
import { nojaFormSentCacheKey } from '@root/utils'

export const NojaPage: React.FC = () => {
  const { slug } = useBusinessContext()

  const [hasSentForm, setHasSentForm] = useLocalStorage(nojaFormSentCacheKey(slug), false)

  return (
    <StyledPage>
      {hasSentForm ? <NojaThankYou /> : <NojaSendForm onSuccess={() => setHasSentForm(true)} />}
    </StyledPage>
  )
}

const StyledPage = styled.div`
  width: 100dvw;
  height: 100dvh;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.neutralGray};
  padding: ${({ theme }) => theme.spacing.xxl}rem;

  @media (max-width: 768px) {
    padding: 0;
  }
`
